import { GLDistributionTable } from "../../../../settlement/src/GLDistributionTable";
import { Checkbox, DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOffice401kHistory extends Layout {
    checkboxIsVoid: Checkbox;
    dataheaderOffice401kHistory: DataHeader;
    layoutGLDistribution: GLDistributionTable;
    sourceJournalOffice: DataSource;
    sourceOff401kHist: DataSource;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabsetOffice401kHistory: Tabset;
    textboxCheckNumber: Textbox;
    textboxContribType: Textbox;
    textboxContribution: Textbox;
    textboxDeductionDate: Textbox;
    textboxDeductionId: Textbox;
    textboxFundId: Textbox;
    textboxMatchingAmount: Textbox;
    textboxPayeeId: Textbox;
    textboxVoidDate: Textbox;
}
